<template>
  <v-container>
    <v-layout column
      v-for="(awardList, awardHeader) in awards"
      class="my-3"
      :key="awardHeader"
    >
      <h1 class="headline text-capitalize">{{ awardHeader }}</h1>
      <v-layout wrap row justify-center>
        <award-icon v-for="award in awardList"
          :key="award.id"
          :award="award"
          @mouseover="activeAward = award"
          @mouseleave="activeAward = null"
        />
      </v-layout>
    </v-layout>

    <award-card :award="activeAward"/>
  </v-container>
</template>

<script>
import AwardIcon from '@/components/awards/AwardIcon.vue';
import AwardCard from '@/components/awards/AwardCard.vue';
import awards from '@/assets/data/awards.json';

export default {
  components: {
    'award-icon': AwardIcon,
    'award-card': AwardCard,
  },

  data() {
    return {
      awards,
      activeAward: null,
    };
  },
};
</script>
